/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { pacientesControllerActualizarInformacionPersonal } from '../fn/pacientes/pacientes-controller-actualizar-informacion-personal';
import { PacientesControllerActualizarInformacionPersonal$Params } from '../fn/pacientes/pacientes-controller-actualizar-informacion-personal';
import { pacientesControllerCambiarPassword } from '../fn/pacientes/pacientes-controller-cambiar-password';
import { PacientesControllerCambiarPassword$Params } from '../fn/pacientes/pacientes-controller-cambiar-password';
import { pacientesControllerObtenerInformacionPersonal } from '../fn/pacientes/pacientes-controller-obtener-informacion-personal';
import { PacientesControllerObtenerInformacionPersonal$Params } from '../fn/pacientes/pacientes-controller-obtener-informacion-personal';
import { pacientesControllerVerificarTelefono } from '../fn/pacientes/pacientes-controller-verificar-telefono';
import { PacientesControllerVerificarTelefono$Params } from '../fn/pacientes/pacientes-controller-verificar-telefono';
import { UsuarioInfoPersonalDto } from '../models/usuario-info-personal-dto';

@Injectable({ providedIn: 'root' })
export class PacientesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `pacientesControllerObtenerInformacionPersonal()` */
  static readonly PacientesControllerObtenerInformacionPersonalPath = '/api/pacientes/obtener-informacion-personal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pacientesControllerObtenerInformacionPersonal()` instead.
   *
   * This method doesn't expect any request body.
   */
  pacientesControllerObtenerInformacionPersonal$Response(params?: PacientesControllerObtenerInformacionPersonal$Params, context?: HttpContext): Observable<StrictHttpResponse<UsuarioInfoPersonalDto>> {
    return pacientesControllerObtenerInformacionPersonal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pacientesControllerObtenerInformacionPersonal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pacientesControllerObtenerInformacionPersonal(params?: PacientesControllerObtenerInformacionPersonal$Params, context?: HttpContext): Observable<UsuarioInfoPersonalDto> {
    return this.pacientesControllerObtenerInformacionPersonal$Response(params, context).pipe(
      map((r: StrictHttpResponse<UsuarioInfoPersonalDto>): UsuarioInfoPersonalDto => r.body)
    );
  }

  /** Path part for operation `pacientesControllerActualizarInformacionPersonal()` */
  static readonly PacientesControllerActualizarInformacionPersonalPath = '/api/pacientes/actualizar-informacion-personal';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pacientesControllerActualizarInformacionPersonal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pacientesControllerActualizarInformacionPersonal$Response(params: PacientesControllerActualizarInformacionPersonal$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pacientesControllerActualizarInformacionPersonal(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pacientesControllerActualizarInformacionPersonal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pacientesControllerActualizarInformacionPersonal(params: PacientesControllerActualizarInformacionPersonal$Params, context?: HttpContext): Observable<void> {
    return this.pacientesControllerActualizarInformacionPersonal$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pacientesControllerVerificarTelefono()` */
  static readonly PacientesControllerVerificarTelefonoPath = '/api/pacientes/verificar-telefono';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pacientesControllerVerificarTelefono()` instead.
   *
   * This method doesn't expect any request body.
   */
  pacientesControllerVerificarTelefono$Response(params?: PacientesControllerVerificarTelefono$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pacientesControllerVerificarTelefono(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pacientesControllerVerificarTelefono$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  pacientesControllerVerificarTelefono(params?: PacientesControllerVerificarTelefono$Params, context?: HttpContext): Observable<void> {
    return this.pacientesControllerVerificarTelefono$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `pacientesControllerCambiarPassword()` */
  static readonly PacientesControllerCambiarPasswordPath = '/api/pacientes/cambiar-password';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pacientesControllerCambiarPassword()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pacientesControllerCambiarPassword$Response(params: PacientesControllerCambiarPassword$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return pacientesControllerCambiarPassword(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `pacientesControllerCambiarPassword$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  pacientesControllerCambiarPassword(params: PacientesControllerCambiarPassword$Params, context?: HttpContext): Observable<void> {
    return this.pacientesControllerCambiarPassword$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
